export const maxDaysAgoCancelNotruf = 15;
